import { Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const NoResult = ({link, name}) => {
    return ( 
        <Container className="d-flex justify-content-center align-items-center flex-column gap-3" style={{height: '60vh'}}>
            <h4>No {name} available</h4>
            <Link to={link}>
                <Button>Add {name}</Button>
            </Link>
        </Container>
     );
}
 
export default NoResult;